/**
 * Created by WorkAxis www.workaxis.in
 * Services page — AI & product engineering partner.
 */
import React from 'react';
import "./style.css";
import {Link} from "react-router-dom";
import {
    serviceBuckets,
    howWeWork,
    howWeWorkNote,
    typicalEngagements,
    techStack,
    workFlow
} from "./data";
import {useReveal, PageHero, CtaSection} from "./shared";

export default function Services() {
    useReveal();

    return (
        <div>
            <PageHero
                kicker="Services"
                title={<>AI & product engineering, <span className="wx-grad-text">end to end.</span></>}
                lead="We partner with businesses that need production-ready software and AI — not a generic
                      development vendor. One team owns discovery, architecture, build, deploy, and scale."
            />

            {/* ---------- Service buckets ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <div className="wx-services-grid is-detailed is-four-buckets">
                        {serviceBuckets.map((s, i) => (
                            <div key={s.name} className="wx-service-card wx-reveal"
                                 style={{transitionDelay: `${(i % 2) * 90}ms`}}>
                                <div className="wx-service-index">{String(i + 1).padStart(2, '0')} /</div>
                                <div className="wx-service-title">{s.name}</div>
                                <div className="wx-service-desc">{s.tagline}</div>
                                <p className="wx-bucket-desc">{s.desc}</p>
                                <ul className="wx-product-points">
                                    {s.points.map((p) => <li key={p}>{p}</li>)}
                                </ul>
                                <div className="wx-chip-row">
                                    {s.examples.slice(0, 4).map((ex) => (
                                        <span className="wx-chip is-small" key={ex}>{ex}</span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- How we work ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <div className="wx-section-head wx-reveal">
                        <div className="wx-kicker">How we work</div>
                        <h2 className="wx-h2">From business problem to production.</h2>
                        <p className="wx-lead">{howWeWorkNote}</p>
                    </div>
                    <div className="wx-process is-four">
                        {howWeWork.map((item, i) => (
                            <div key={item.step} className="wx-process-step wx-reveal"
                                 style={{transitionDelay: `${i * 90}ms`}}>
                                <div className="wx-process-num">{String(i + 1).padStart(2, '0')}</div>
                                <div className="wx-process-name">{item.step}</div>
                                <p className="wx-process-desc">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                    <div className="wx-section-link wx-reveal">
                        <Link to="/contact" className="wx-btn wx-btn-primary">Discuss your project</Link>
                    </div>
                </div>
            </section>

            {/* ---------- Typical engagements ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <div className="wx-section-head wx-reveal">
                        <div className="wx-kicker">Typical engagements</div>
                        <h2 className="wx-h2">Flexible models — scoped after we understand your problem.</h2>
                    </div>
                    <div className="wx-services-grid is-three">
                        {typicalEngagements.map((e, i) => (
                            <div key={e.name} className="wx-service-card wx-reveal"
                                 style={{transitionDelay: `${i * 90}ms`}}>
                                <div className="wx-service-title">{e.name}</div>
                                <div className="wx-service-desc">{e.desc}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- Tech stack ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <div className="wx-section-head wx-reveal">
                        <div className="wx-kicker">Technology</div>
                        <h2 className="wx-h2">A proven, modern stack.</h2>
                    </div>
                    <div className="wx-chips wx-reveal">
                        {techStack.map((t) => <span className="wx-chip" key={t}>{t}</span>)}
                    </div>
                </div>
            </section>

            {/* ---------- Process ---------- */}
            <section className="wx-section" id="process">
                <div className="wx-container">
                    <div className="wx-section-head wx-reveal">
                        <div className="wx-kicker">Delivery process</div>
                        <h2 className="wx-h2">Transparent at every step.</h2>
                        <p className="wx-lead">
                            Discovery-first delivery — from workflow mapping to operating in production.
                        </p>
                    </div>
                    <div className="wx-process">
                        {workFlow.map((step, i) => (
                            <div key={step} className="wx-process-step wx-reveal"
                                 style={{transitionDelay: `${(i % 4) * 90}ms`}}>
                                <div className="wx-process-num">{String(i + 1).padStart(2, '0')}</div>
                                <div className="wx-process-name">{step}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <CtaSection
                title={<>Get a <span className="wx-grad-text">solution assessment</span></>}
                text="Tell us what you're trying to automate or build. We'll respond within one business day with next steps."
                primaryLabel="Discuss your project"
            />
        </div>
    );
}
